// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import visitStatusEntity from './entities/visit-status.json';
import visitStatusMenu from '../pages/visit-status/menu.json';
import visitStatusFullForm from '../pages/visit-status/forms/full.json';
import visitStatusContextForm from '../pages/visit-status/forms/context.json';
import visitStatusMiniForm from '../pages/visit-status/forms/mini.json';
import visitStatusLookupForm from '../pages/visit-status/forms/lookup.json';
import visitStatusTableView from '../pages/visit-status/views/table.json';
import visitStatusDashboardView from '../pages/visit-status/views/dashboard.json';

/** Тип запису «Статус візиту» зі сторінками пакета: меню, форми та подання з pages/visit-status/. */
export const visitStatusDefinition: IRecordTypeDefinition = {
  ...visitStatusEntity,
  views: assembleViewSet({
      table: visitStatusTableView,
      dashboard: visitStatusDashboardView,
  }),
  form: visitStatusFullForm,
  forms: { full: visitStatusFullForm, context: visitStatusContextForm, mini: visitStatusMiniForm, lookup: visitStatusLookupForm },
  menu: visitStatusMenu,
} as IRecordTypeDefinition;
